import { createContext, useContext } from "react";
import type { Api } from "./api.js";
import type { Auth } from "./auth.js";

// What every page needs: the API client and sign-in.
export type AppServices = { api: Api; auth: Auth };

export const Services = createContext<AppServices | null>(null);

export function useServices(): AppServices {
  const services = useContext(Services);
  if (!services) throw new Error("useServices outside <Services.Provider>");
  return services;
}

export const useApi = () => useServices().api;
